if (
  !customElements.get(
    'launch-announcement-countdown'
  )
) {

  customElements.define(
    'launch-announcement-countdown',

    class LaunchAnnouncementCountdown
      extends HTMLElement {

      constructor() {
        super();

        this.timer = null;
      }


      connectedCallback() {

        this.start();

      }


      disconnectedCallback() {

        this.stop();

      }


      pad(value) {

        return String(
          Math.max(
            0,
            Number(value) || 0
          )
        ).padStart(2, '0');

      }


      parseDeadline() {

        const raw =
          String(
            this.dataset.deadline || ''
          ).trim();


        if (!raw) {
          return NaN;
        }


        /*
         * Also accept timestamp values
         */

        const numeric =
          Number(raw);


        if (
          Number.isFinite(numeric) &&
          numeric > 0
        ) {

          if (
            numeric <
            100000000000
          ) {

            return numeric * 1000;

          }


          return numeric;

        }


        return Date.parse(raw);

      }


      setValue(
        selector,
        value
      ) {

        const el =
          this.querySelector(
            selector
          );


        if (el) {

          el.textContent =
            this.pad(value);

        }

      }


      renderZero() {

        this.setValue(
          '[data-lac-days]',
          0
        );

        this.setValue(
          '[data-lac-hours]',
          0
        );

        this.setValue(
          '[data-lac-minutes]',
          0
        );

        this.setValue(
          '[data-lac-seconds]',
          0
        );

      }


      tick() {

        const deadline =
          this.parseDeadline();


        if (
          !Number.isFinite(
            deadline
          )
        ) {

          this.renderZero();

          return false;

        }


        const remaining =
          deadline -
          Date.now();


        if (
          remaining <= 0
        ) {

          this.renderZero();


          if (
            this.dataset
              .expiredBehavior
            === 'hide'
          ) {

            this.hidden = true;

          }


          return false;

        }


        this.hidden = false;


        const totalSeconds =
          Math.floor(
            remaining / 1000
          );


        const days =
          Math.floor(
            totalSeconds /
            86400
          );


        const hours =
          Math.floor(
            (
              totalSeconds %
              86400
            ) / 3600
          );


        const minutes =
          Math.floor(
            (
              totalSeconds %
              3600
            ) / 60
          );


        const seconds =
          totalSeconds % 60;


        this.setValue(
          '[data-lac-days]',
          days
        );


        this.setValue(
          '[data-lac-hours]',
          hours
        );


        this.setValue(
          '[data-lac-minutes]',
          minutes
        );


        this.setValue(
          '[data-lac-seconds]',
          seconds
        );


        return true;

      }


      start() {

        this.stop();


        this.tick();


        this.timer =
          window.setInterval(
            () => {

              const active =
                this.tick();


              if (!active) {

                this.stop();

              }

            },
            1000
          );

      }


      stop() {

        if (
          this.timer
        ) {

          clearInterval(
            this.timer
          );


          this.timer = null;

        }

      }

    }

  );

}